import AuthContext from '../context/authContext';
import { useEffect, useState ,useContext } from 'react';

import MenuLinks, { LogoutMenu } from '../components/menuLink/menuLinks';

import { ReactComponent as ArrowMenu } from '../assets/icons/arrows/arr079.svg';
import { ReactComponent as Profile } from '../assets/icons/menu/Profile.svg';
import { ReactComponent as Room } from '../assets/icons/menu/Display.svg';
import { ReactComponent as Wallet } from '../assets/icons/menu/Wallet.svg';
import { ReactComponent as Message } from '../assets/icons/menu/Message.svg';
import { ReactComponent as Cart } from '../assets/icons/menu/Cart.svg';
import { ReactComponent as Notif2 } from '../assets/icons/menu/notif-2.svg';
import { ReactComponent as Setting } from '../assets/icons/menu/setting.svg';
import { ReactComponent as Menu } from '../assets/icons/menu/menu.svg'
import dashboardIcon from "../assets/images/menuIcons/icons8-dashboard-50.png"
import blogIcon from "../assets/images/menuIcons/icons8-blog-64.png"
import categoryIcon from "../assets/images/menuIcons/icons8-categories-64.png"
import workshopIcon from "../assets/images/menuIcons/icons8-workshop-50.png"
import discountIcon from "../assets/images/menuIcons/icons8-discount-50.png"
import orderIcon from "../assets/images/menuIcons/icons8-order-100.png"
import smsIcon from "../assets/images/menuIcons/icons8-sms-50.png"
import galleryIcon from "../assets/images/menuIcons/icons8-gallery-48.png"


import sampleUser from '../assets/images/user.png'

// import { ReactComponent as Add } from '../assets/icons/generals/add.svg'

// import '../style/App.scss';

const Layout = (props) => {

    const [matches, setMatches] = useState(true)
    const auth = JSON.parse(localStorage.getItem("za_token"))
    
    const [hoverMenu, setHoverMenu] = useState(false);
    const [activeMenu, setActiveMenu] = useState(false);

    useEffect(() => {
        if (window.screen.width < 768) {
            setMatches(false)
            closeMenu(true)
        }
    }, []);

    const openMenu = () => {

        // if (matches) {
        document.getElementById("sidebar").style.width = "265px";
        // }
    }
    const closeMenu = (initial) => {
        // console.log(matches);
        if (initial) {
            document.getElementById("sidebar").style.width = "0px";
        }
        else if (matches) {
            document.getElementById("sidebar").style.width = "75px";
        }
        else {
            document.getElementById("sidebar").style.width = "0px";
        }

    }



    return (
        <div className="app_container" >
            <div className="container wsm:!p-0" style={{ paddingRight: activeMenu ? "75px" : "265px", maxWidth: "unset" }}>
                <div className='sidebar' onMouseEnter={() => { activeMenu && matches && openMenu(); activeMenu && setHoverMenu(false) }}
                    onMouseLeave={() => { activeMenu && closeMenu(); activeMenu && setHoverMenu(true) }} id='sidebar'>
                    <div className='sidebar-header items-center'>
                        <div style={{ display: `${matches && hoverMenu ? "none" : ""}` }}>
                            {/* <img src={afagh} alt="" className='w-[50px]' /> */}
                        </div>
                        <div onClick={() => matches ? setActiveMenu(perv => !perv) : closeMenu()} className={`menu-arrow ${activeMenu ? "active-arrow" : "staible-menu"}`}>
                            <ArrowMenu />
                        </div>
                    </div>
                    <div className="flex flex-col justify-between h-full">
                        <div className="menu-link-container">
                            <MenuLinks title={"داشبورد"} image={dashboardIcon} link={"/admin/dashboard"} />
                            <MenuLinks title={"دسته بندی ها"} image={categoryIcon} link={"/admin/categories"} />
                            <MenuLinks title={"بلاگ"} image={blogIcon} link={"/admin/blogs"} />
                            <MenuLinks title={"دوره ها"} image={blogIcon} link={"/admin/course"} />
                            <MenuLinks title={"ورک شاپ"} image={workshopIcon} link={"/admin/workshop"} />
                            <MenuLinks title={"تخفیف ها"}image={discountIcon} link={"/admin/discounts"} />
                            <MenuLinks title={"گالری"} image={galleryIcon} link={"/admin/galleries"} />
                            <MenuLinks title={"نظرات"} icon={<Message color='#000000' />} link={"/admin/comments"} />
                            <MenuLinks title={"سفارشات"} image={orderIcon} link={"/admin/orders"} />
                            <MenuLinks title={"کاربران"} icon={<Profile fill='#000' width={"20"} height="20" />} link={"/admin/users"} />
                            <MenuLinks title={"اعلامیه ها"} icon={<Notif2 fill='#000' width={"20"} height="20" />} link={"/admin/notifications"} />
                            <MenuLinks title={"کاوه نگار"} image={smsIcon}link={"/admin/kavenegar"} />
                        </div>
                        <div className='mb-2'>
                            <MenuLinks title="اطلاعات وبسایت" icon={<Setting width={"20"} height="20" />} link={"/admin/website/info"} />
                            <MenuLinks title="تنظیمات" icon={<Setting width={"20"} height="20" />} link={"/admin/profile/setting"} />
                            <div className='mt-3'>
                                <LogoutMenu title="خروج از حساب" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* header side */}
                <header>
                    <div className='user-details !justify-between items-center !py-4 !shadow-xl text-xs bg-[#080B0A] text-white'>
                        <div className='flex'>
                            <span className='hidden ml-2 wsm:!block' onClick={() => !matches && openMenu()}>
                                <Menu fill='#fff' />
                            </span>
                        </div>
                        <ul>
                            <li>{auth.user_name ? auth.user_name : "وارد حساب خود شوید"}</li>
                            <li><img src={sampleUser} alt="" className='userprofile !border-white bg-white' /></li>
                        </ul>
                    </div>
                    {/* <div className='page-details'>
                        <h2>{props.title}</h2>
                    </div> */}
                </header>
                {/* main secetion */}
                <main className={`component-container ${activeMenu ? "main-full" : ''} wsm:!m-0 wsm:!px-0`}>
                    {
                        props.children
                    }
                </main>
            </div>
        </div >
    )
}

export default Layout